import toastr from "toastr";

export type AdvisorViewTarget = { distroAccountUserId: string } | { advisorId: string };

export const openAdvisorView = async (target: AdvisorViewTarget) => {
    const tab = window.open("", "_blank");
    try {
        const response = await fetch("/api/sso/advisorview", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(target),
        });
        if (!response.ok) {
            if (tab) tab.close();
            const reason = response.status === 400 ? await response.text() : "";
            toastr.error(reason ? `Could not open the advisor portal: ${reason}` : "Could not open the advisor portal");
            return;
        }
        const res = await response.json();
        if (tab) {
            tab.location.href = res.url;
        } else {
            window.location.href = res.url;
        }
    } catch (e) {
        if (tab) tab.close();
        toastr.error("Could not open the advisor portal");
    }
};
